export const telephonyFr = {
  admin: {
    title: "Centre de contrôle de téléphonie et d'IA",
    subtitle:
      'Traitement audio, service de transcription, modèle linguistique et activation par utilisateur.',
    tabEngine: 'Moteur audio et IA',
    tabUsers: "Activation de l'utilisateur",
    error: "La configuration n'a pas pu être chargée.",
    saved: 'La configuration a été enregistrée.',
    engineTitle: 'Moteur audio et STT',
    engineHint:
      "L'enregistrement est récupéré après l'appel, transcrit puis analysé par le modèle de langage.",
    enabled: 'Analyse IA active',
    enabledHint:
      "Lorsque l'analyse est désactivée, les enregistrements sont uniquement enregistrés.",
    mode: 'Mode de traitement audio',
    modeHint:
      'La détection automatique sélectionne par nombre de canaux : la stéréo est transcrite par canal, le mono est séparé par la diarisation des haut-parleurs.',
    whisperUrl: "URL de l'API Whisper/WhisperX",
    whisperKey: "Jeton d'authentification Whisper",
    ollamaUrl: 'URL du serveur Ollama',
    ollamaUrlHint:
      'Localement "http://localhost:11434" ou sur le réseau "http://192.168.1.50:11434".',
    ollamaModel: 'Modèle Ollama',
    prompt: "Invite d'extraction",
    promptHint:
      "L'espace réservé {{transcript}} est remplacé par la transcription formatée du locuteur.",
    secretSet: 'Stocké ({{hint}}). Le laisser vide conserve la valeur enregistrée.',
    secretUnset: 'Aucun jeton stocké.',
  },
  modes: {
    AUTO_DETECT: 'Détection automatique (stéréo → chuchotement plus rapide / mono → WhisperX)',
    STEREO_SPLIT_FASTER_WHISPER: 'Forcé : stéréo double canal (chuchotement plus rapide)',
    MONO_DIARIZATION_WHISPERX: 'Forcé : diarisation du haut-parleur mono (WhisperX)',
    SINGLE_CHANNEL_PLAIN: 'Mono simple sans séparation des enceintes',
  },
  test: {
    title: 'Test de pipeline',
    subtitle:
      'Téléchargez un fichier de test et vérifiez toute la chaîne de détection de format, de transcription et de résumé.',
    upload: 'Téléchargez le fichier de test et vérifiez le pipeline STT/LLM',
    running: "Le pipeline est en cours d'exécution. Selon la durée, cela prend quelques minutes.",
    success: "Le pipeline s'est terminé avec succès.",
    failed: "Le pipeline s'est terminé avec une erreur.",
    tooLarge: 'Le fichier de test dépasse {{size}} Mo.',
    transcript: 'Transcription',
    summary: 'Résumé',
    checkedAt: 'Vérifié à {{timestamp}}',
    steps: {
      ANALYSIS: 'Détection de format',
      TRANSCRIPTION: 'Transcription',
      SUMMARY: 'Résumé',
    },
  },
  users: {
    title: 'Activation par utilisateur',
    subtitle:
      "La téléphonie est activée uniquement par compte utilisateur. Sans identifiant d'agent, numéro d'appel direct ou poste, les appels entrants ne peuvent pas être répondus.",
    error: "La liste des utilisateurs n'a pas pu être chargée.",
    empty: "Il n'y a aucun utilisateur.",
    saved: "L'activation a été enregistrée.",
    user: 'Employé',
    providerUserId: "Identifiant de l'agent",
    providerUserIdHint: 'ID utilisateur Ringover, par exemple 1234567.',
    numbers: 'Numéros de téléphone',
    extension: 'Extension interne',
    extensionPlaceholder: '101',
    directDial: 'Numérotation directe (E.164)',
    directDialPlaceholder: '+4961421234512',
    outboundCallerId: 'CLI sortante',
    outboundCallerIdPlaceholder: '+496142123450',
    outboundCallerIdHint: 'Numéro affiché à la personne appelée.',
    apiKey: 'Clé API personnelle',
    apiKeyPlaceholder: 'Entrez une nouvelle clé',
    apiKeySet: 'Stocké ({{hint}}). Laissez vide pour conserver la valeur enregistrée.',
    apiKeyUnset: 'Aucune clé stockée.',
    showKey: 'Afficher la clé',
    hideKey: 'Masquer la clé',
    enabled: 'Actif',
    toggle: 'Activer la téléphonie pour {{name}}',
    test: 'Test',
    testHint: "Vérifiez la connexion à l'aide des informations d'identification stockées",
    testRunning: 'Le test de connexion est en cours.',
    testSuccess: 'Connexion établie : {{name}}',
    testSuccessAnonymous: 'La connexion au fournisseur fonctionne.',
    providerHint: 'Fournisseurs pris en charge : {{providers}}.',
  },
  webhook: {
    title: 'Point d’accès du webhook Ringover',
    hint: "Saisissez cette URL et le secret dans le tableau de bord développeur Ringover pour recevoir les événements d'appels et les enregistrements en temps réel.",
    url: 'URL du webhook',
    copy: 'Copier',
    copied: "L'URL du webhook a été copiée.",
    copyFailed: "L'URL n'a pas pu être copiée. Veuillez le sélectionner manuellement.",
    secret: 'Secret global du webhook',
    secretPlaceholder: 'Entrez un nouveau secret',
    secretHint:
      "Clé de signature pour toutes les livraisons entrantes. Cela s'applique à l'ensemble de l'installation car Ringover utilise exactement un secret par intégration.",
    secretSet: 'Stocké ({{hint}}). Laissez vide pour conserver la valeur enregistrée.',
    secretUnset: "Aucun secret stocké pour l'instant : les livraisons entrantes sont rejetées.",
    masterKey: "Clé API d'administrateur Ringover (facultatif)",
    masterKeyHint:
      "Utilisé pour les requêtes à l'échelle de l'installation et non strictement requis.",
    save: 'Enregistrer',
    saved: 'La configuration du fournisseur a été enregistrée.',
    error: "La configuration du fournisseur n'a pas pu être chargée.",
  },
  list: {
    subtitle: 'Appels avec ce partenaire commercial, y compris transcription et analyse IA.',
    error: "L'historique des appels n'a pas pu être chargé.",
    emptyTitle: 'Aucun appel enregistré pour le moment',
    emptyHint: "Dès qu'un appel a eu lieu, il apparaîtra ici.",
    selectHint: 'Sélectionnez un appel pour voir son analyse.',
    showTranscript: 'Afficher la transcription',
    callNow: 'Appeler {{number}}',
    noPermission: "Vous n'êtes pas autorisé à consulter l'historique des appels.",
  },
  fields: {
    startedAt: 'Heure',
    direction: 'Orientation',
    agent: 'Agent',
    status: 'Statut',
    duration: 'Durée (min)',
    actions: 'Actions',
  },
  directions: {
    INBOUND: 'Entrant',
    OUTBOUND: 'Sortant',
  },
  statuses: {
    RINGING: 'Sonnerie',
    ANSWERED: 'Répondu',
    MISSED: 'Manqué',
    VOICEMAIL: 'Messagerie vocale',
    FAILED: 'Échec',
  },
  sentiments: {
    POSITIVE: 'Positif',
    NEUTRAL: 'Neutre',
    NEGATIVE: 'Négatif',
    DISPUTED: 'Contesté',
  },
  processing: {
    PENDING: "L'analyse est mise en file d'attente.",
    DOWNLOADING_AUDIO: "Récupération de l'enregistrement…",
    TRANSCRIBING: "Transcription de l'appel…",
    SUMMARIZING: 'Le modèle de langage résume…',
    COMPLETED: 'Analyse terminée.',
    FAILED: "L'analyse a échoué.",
    DISABLED: "L'analyse IA est désactivée à l'échelle du système.",
  },
  summary: {
    title: "Résumé de l'IA",
    empty: "Aucun résumé n'est disponible pour cet appel.",
    edit: 'Modifier le résumé',
    editorLabel: 'Résumé',
    saved: 'Le résumé a été enregistré.',
    editedBadge: 'Edité par {{name}} sur {{timestamp}}',
    showOriginal: "Afficher le texte original de l'IA",
    actionItems: "Éléments d'action",
    reprocess: "Redémarrer l'analyse",
    reprocessStarted: "L'analyse a été redémarrée.",
  },
  transcript: {
    title: "Transcription de l'appel",
    subtitle: 'Mode de traitement : {{mode}}',
    modeUnknown: 'inconnu',
    empty: "Aucune transcription n'est disponible pour cet appel.",
    showPlain: 'Texte brut',
    showDialog: 'Dialogues',
    agent: 'Agent',
    customer: 'Client',
  },
  screenPop: {
    title: 'Appel entrant',
    unknown: "Aucun partenaire n'est enregistré pour ce numéro.",
    openDocuments: 'Documents ouverts {{count}}',
    lastCall: 'Dernier appel : {{timestamp}}',
    open: 'Contact ouvert',
    blockedTitle: '🚨 Verrouillé : {{status}}',
    blockedReason: 'Raison : {{reason}}',
  },
  call: {
    started: 'L’appel a démarré. Veuillez le prendre sur votre appareil.',
    failed: 'Impossible de démarrer l’appel : {{message}}',
  },
} as const;
